export default __webpack_public_path__ + "static/media/img5.85a2d709.jpg";